import React from "react";
import ContactSection from "../components/ContactSection";
import PageSeo from "../components/PageSeo";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";

export default function ContactPage() {
  const { lang } = useLang();
  const settings = useSettings();

  const seoTitle = lang === "en" ? settings.contact_meta_title_en : settings.contact_meta_title_it;
  const seoDesc = lang === "en" ? settings.contact_meta_desc_en : settings.contact_meta_desc_it;

  return (
    <div className="pt-24 bg-[#09090b] min-h-screen" data-testid="contact-page">
      <PageSeo title={seoTitle} description={seoDesc} pathIt="/it/contatti" pathEn="/en/contact" />
      <ContactSection settings={settings} />
    </div>
  );
}
